import styled from 'styled-components';
import { ContainerSection } from '@/main/components/shared/styles';

export const Container = styled(ContainerSection)`
  display: grid;
  grid-template-areas: 'header header' 'evaluation scoreAverage';
  gap: 1rem;
  border-radius: 6px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-areas: 'header' 'evaluation' 'scoreAverage';
  }
`;

export const AreaEvaluation = styled.div`
  grid-area: evaluation;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
export const AreaRowEvaluation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 1rem;
  background: ${({ theme }) => theme.white};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column-reverse;
  }
`;
export const TitleEvaluation = styled.div``;
export const TitleTooltip = styled.div`
  margin: 0;
`;

export const AreaScoreAverage = styled.div`
  grid-area: scoreAverage;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.white};
`;

export const TitleScoreAverage = styled.h4`
  color: #000;
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
`;
export const ScoreAverage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > p {
    margin: 0;
  }
`;

